import ImportPicksButton from "../containers/import-picks-button";
import pure from "./higher-order/pure";
import React from "react";
import selectPage from "../select-page";

export default pure(function PlayFieldFooter({ myTickets, page, pageSize, tournament }) {

  var prevPage = null;
  var nextPage = null;
  if (myTickets.size > pageSize) {
    prevPage = (
      <div className="game-table_cell game-table_cell--nav" />
    );
    nextPage = (
      <div className="game-table_cell game-table_cell--nav" />
    );
  }

  var importColumns = selectPage(myTickets, page, pageSize).map((ticket) => (
    <ImportPicksButton key={ticket.get("ticket_number")} ticket={ticket} tournament={tournament} />
  ));
  return (
    <div className="tournament-table tournament-table--is-transparent">
      <div className="game-table">
        <div className="game-table_row">
          <div className="game-table_cell game-table_cell--action game-table_cell--race" />

          <div className="game-table_cell game-table_cell--track" />

          <div className="game-table_cell game-table_cell--overview" />

          <div className="game-table_cell game-table_cell--results" />

          {prevPage}

          {importColumns}

          {nextPage}
        </div>
      </div>
    </div>
  );
});
